import { render } from "./ProspectsList.vue?vue&type=template&id=496cb197"
import script from "./ProspectsList.vue?vue&type=script&lang=js"
export * from "./ProspectsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__